import { Button, Form, Popup } from 'devextreme-react';
import { useScreenSize } from '../../../utils/media-query';
import { useAppSelector } from '../../../contexts/hooks';
import { Item, Label } from 'devextreme-react/form';
import { ToolbarItem } from 'devextreme-react/popover';
import { useCallback, useRef } from 'react';
import DropDownGrid from '../../../components/library/drop-down-grid/DropDownGrid';

const FieldsToFilters = {
  Mto_Us_Id: '',
  Mto_Ord_Id: '',
  Mto_Est_Id: '',
  Mto_Es_Id: '',
  Mto_An_Id: '',
  Mto_Acm_Id: '',
  Mto_Fecha: [new Date(), new Date()],
};

export const ModalFilter = ({ visible, handleApplyFilter, handleCancelFilter }) => {
  const { isXSmall } = useScreenSize();
  const { LstAccionesMonitoreo, LstUsuarios } = useAppSelector((x) => x.configuration);
  const LstEstudios = useAppSelector((x) => x.configuration.Data?.Estudios);
  const frmRef = useRef<Form>(null);
  const handleCancel = useCallback(() => {
    frmRef.current?.instance.resetValues();
    handleCancelFilter();
  }, [FieldsToFilters]);

  const handleConfirm = useCallback(() => {
    if (frmRef.current?.instance) {
      if (!frmRef.current.instance.validate().isValid) {
        return;
      }
      handleApplyFilter(FieldsToFilters);
    }
  }, [FieldsToFilters]);

  return (
    <Popup height='auto' title='Filtrar trazabilidad' fullScreen={isXSmall} hideOnOutsideClick={true} width={500} visible={visible} dragEnabled={true} showTitle={true}>
      <Form ref={frmRef} formData={FieldsToFilters}>
        <Item dataField='Mto_Fecha' isRequired editorType='dxDateRangeBox' editorOptions={{ displayFormat: 'shortdate' }}>
          <Label text='Fecha' />
        </Item>
        <Item dataField='Mto_Us_Id' render={() => (
          <DropDownGrid
            dataSource={LstUsuarios}
            valueExpr='Us_Id'
            displayExpr='Us_Nombre'
            placeholder='Seleccionar usuario...'
            dropDownWidth={500}
            dropDownHeight={360}
            onValueChanged={(e) => {
              frmRef.current?.instance.updateData('Mto_Us_Id', e.value);
            }}
            columns={[{ dataField: 'Us_Nombre', caption: 'Usuario' }]}
          />
        )}>
          <Label text='Usuario' />
        </Item>
        <Item dataField='Mto_Ord_Id'>
          <Label text='Orden' />
        </Item>
        <Item dataField='Mto_Es_Id' cssClass='full-width-item' render={() => (
          <DropDownGrid
            dataSource={LstEstudios}
            valueExpr='Es_Id'
            displayExpr='Es_Nombre'
            placeholder='Seleccionar estudio...'
            dropDownWidth={700}
            dropDownHeight={420}
            onValueChanged={(e) => {
              frmRef.current?.instance.updateData('Mto_Es_Id', e.value);
            }}
            columns={[{ dataField: 'Es_Nombre', caption: 'Estudio' }, { dataField: 'Es_Codigo', caption: 'Código' }]}
          />
        )}>
          <Label text='Estudio' />
        </Item>
        {/* <Item dataField='Mto_An_Id' >
          <Label text='Analito'/>
        </Item> */}
        <Item dataField='Mto_Acm_Id' editorOptions={{ dataSource: LstAccionesMonitoreo, showClearButton:true, showDataBeforeSearch: true, minSearchLength: 2, searchTimeout: 200, searchEnabled: true, displayExpr: 'Acm_Nombre', valueExpr: 'Acm_Id' }} editorType='dxSelectBox'>
          <Label text='Acciones' />
        </Item>
      </Form>
      <ToolbarItem toolbar='bottom' location='after'>
        <div className={`form-popup-buttons-container`}>
          <Button text='Cancelar' stylingMode='contained' onClick={handleCancel} />
          <Button text='Confirmar' stylingMode='contained' type='default' onClick={handleConfirm} />
        </div>
      </ToolbarItem>
    </Popup>
  );
};
